import classnames from "classnames";
import {
  faCirclePlus,
  faFile,
  faLayerGroup,
  faGear,
  faCircleXmark,
  faCircleInfo,
  faPuzzlePiece,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import { GrigoraEditorContext } from "../context";
import Elements from "./elements";
import Layer from "./layer";
import "./index.scss";
import { Tooltip } from "../../input";
import { Link } from "react-router-dom";
import ProjectSettings from "./settings";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { GrigoraVersioningContext } from "../../versioning/context";
import _, { set } from "lodash";
import Components from "./components";
import { AnimatePresence, motion } from "framer-motion";
import { Rnd } from "react-rnd";
import { SettingsPanel } from "../grigora-right-bar/SettingsPanel";
import { Toolbox } from "../components";
import {
  CirclePlus,
  Component,
  HeadsetIcon,
  InfoEditor,
  InfoIcon,
  Layers,
  Pages,
  SectionIcon,
  SettingsActiveIcon,
  SettingsIcon,
  TypographyIcon,
} from "../../../assets/ui-icons";
import PagesSwitcher from "./pages";
import Typography from "./typography";
import { ModalInput } from "../../ui-kit";
import { ReactComponent as Logo } from "../../../assets/grigoraWhite.svg";
import preval from "preval.macro";
import DateDisplay from "../../ui-kit/date-display";
import Sections from "./sections";
import { WhiteLabelContext } from "../../whitelabel";
import { APP_NAME, SUPPORT_EMAIL, WEBCLIP_URL } from "../../app";

const GrigoraLeftBar = () => {
  const { version, versionName } = useContext(GrigoraVersioningContext);
  const { projectID } = useContext(GrigoraDashboardContext);
  const {
    leftWidget,
    setLeftWidget,
    pageContents,
    pageContentsCheckpoint,
    isAddingBlocks,
    setIsAddingBlocks,
    isAddingSections,
    setIsAddingSections,
    isLayersVisible,
    setIsLayersVisible,
  } = useContext(GrigoraEditorContext);

  const { __whitelabel__ } = useContext(WhiteLabelContext) ?? {};

  const [settingToggle, setSettingToggle] = useState(false);
  const [versionModalToggle, setVersionModalToggle] = useState(false);

  return (
    <motion.div
      initial={{ width: 0 }}
      animate={{ width: 41 }}
      exit={{ width: 0 }}
      transition={{ duration: 0.3, delay: 0.1 }}
      style={{
        clipPath: "inset(0px -200vw -100vh -200vw)",
      }}
      className="flex relative z-[1010] bg-white mt-[-1px] border-r border-gray-200"
      id="editorLeftBar"
    >
      <div className="w-10 flex flex-col text bg-white pt-10">
        <div>
          <Tooltip text={`Add Elements`} placement="right">
            <div
              id="add-elements"
              onClick={() => {
                setLeftWidget("");
                setIsAddingSections(false);
                setIsAddingBlocks(true);
              }}
              className={classnames(
                "grigora-editor-left-sidebar__elements-btn w-10 h-10 flex justify-center items-center cursor-pointer duration-300 hover:bg-gray-200 text-black",
                {
                  active: leftWidget === "elements",
                },
              )}
            >
              <CirclePlus className="w-[28px] h-[28px]" />
            </div>
          </Tooltip>
          <Tooltip text={`Add Sections`} placement="right">
            <div
              id="add-sections"
              onClick={() => {
                setLeftWidget("");
                setIsAddingSections(true);
                setIsAddingBlocks(false);
              }}
              className={classnames(
                "grigora-editor-left-sidebar__sections-btn w-10 h-10 flex justify-center items-center cursor-pointer duration-300 hover:bg-gray-200 text-black",
                {
                  active: leftWidget === "sections",
                },
              )}
            >
              <SectionIcon className="w-[28px] h-[28px]" />
            </div>
          </Tooltip>
          <Tooltip text={`Components`} placement="right">
            <div
              id="components"
              onClick={() => {
                if (leftWidget === "components") {
                  setLeftWidget("");
                } else {
                  setLeftWidget("components");
                  setIsAddingBlocks(false);
                  setIsAddingSections(false);
                }
              }}
              className={classnames(
                "grigora-editor-left-sidebar__components-btn w-10 h-10 flex justify-center items-center cursor-pointer duration-300 hover:bg-gray-200 text-black",
                {
                  active: leftWidget === "components",
                },
              )}
            >
              <Component className="w-[26px] h-[26px]" />
            </div>
          </Tooltip>
          <Tooltip text={`Pages`} placement="right">
            <div
              id="pages"
              onClick={() => {
                if (leftWidget === "pages") {
                  setLeftWidget("");
                } else {
                  setLeftWidget("pages");
                  setIsAddingBlocks(false);
                  setIsAddingSections(false);
                }
              }}
              className={classnames(
                "grigora-editor-left-sidebar__pages-btn w-10 h-10 flex justify-center items-center cursor-pointer duration-300 hover:bg-gray-200 text-black",
                {
                  active: leftWidget === "pages",
                },
              )}
            >
              <Pages className="w-[22px] h-[22px]" />
            </div>
          </Tooltip>
          <Tooltip text={`Typography`} placement="right">
            <div
              id="typography"
              onClick={() => {
                if (leftWidget === "typography") {
                  setLeftWidget("");
                } else {
                  setLeftWidget("typography");
                  setIsAddingBlocks(false);
                  setIsAddingSections(false);
                }
              }}
              className={classnames(
                "grigora-editor-left-typography-btn w-10 h-10 flex justify-center items-center cursor-pointer duration-300 hover:bg-gray-200 text-black",
                {
                  active: leftWidget === "typography",
                },
              )}
            >
              <TypographyIcon className="w-[22px] h-[22px]" />
            </div>
          </Tooltip>
          <Tooltip text={`Settings`} placement="right">
            <div
              id="settings"
              onClick={() => {
                setSettingToggle(true);
              }}
              className={classnames(
                "grigora-editor-left-sidebar__projectsettings-btn w-10 h-10 flex justify-center items-center cursor-pointer duration-300 hover:bg-gray-200 text-black",
                {
                  active: leftWidget === "projectsettings",
                },
              )}
            >
              <SettingsIcon className="w-[22px] h-[22px]" />
            </div>
          </Tooltip>
        </div>
        <div className="mt-auto my-2 ">
          <Tooltip text={`Layers`} placement="right">
            <div
              id="layers"
              onClick={() => {
                setIsLayersVisible(!isLayersVisible);
              }}
              className={classnames(
                "grigora-editor-left-sidebar__layer-btn w-10 h-10 flex justify-center items-center cursor-pointer duration-300 hover:bg-gray-200 text-black",
                {
                  active: leftWidget === "layer",
                },
              )}
            >
              <Layers
                className="w-[22px] h-[22px]"
                style={{
                  color: isLayersVisible ? "#623CE7" : undefined,
                }}
              />
            </div>
          </Tooltip>
          <Tooltip text={`Support`} placement="right">
            <div
              onClick={() => {
                window.location.href = `mailto:${__whitelabel__(
                  "supportEmail",
                  SUPPORT_EMAIL,
                )}?subject=Support Request`;
              }}
              id="support"
              className="w-10 h-10 flex justify-center items-center cursor-pointer  duration-300 hover:bg-gray-200 text-black"
            >
              <HeadsetIcon className="w-[17px] h-[17px]" />
            </div>
          </Tooltip>
          <Tooltip
            text={`Version: ${versionName} (${version})`}
            placement="right"
          >
            <div
              onClick={() => setVersionModalToggle(!versionModalToggle)}
              id="version"
              className="w-10 h-10 flex justify-center items-center cursor-pointer  duration-300 hover:bg-gray-200 text-black"
            >
              <InfoEditor className="w-[22px] h-[22px]" />
            </div>
          </Tooltip>
          <ModalInput
            isOpened={versionModalToggle}
            onOutsideClick={() => {
              setVersionModalToggle(false);
            }}
          >
            <div className="rounded-[21px] bg-white flex flex-col w-[350px] mw-[50vh] py-6 pb-5">
              <div className="flex flex-col justify-center items-center text-grigora-base px-6">
                <img
                  className="w-[100px] h-[100px] object-contain"
                  src={__whitelabel__("icon", WEBCLIP_URL)}
                />
                <h2 className="font-medium text-xl mb-4">
                  {__whitelabel__("platformName", APP_NAME)}
                </h2>
                <div className="flex justify-between items-center w-full my-1">
                  <p>Version Name:</p>
                  <p>{versionName}</p>
                </div>
                <div className="flex justify-between items-center w-full my-1">
                  <p>Version:</p>
                  <p>{version}</p>
                </div>
                <div className="flex justify-between items-center w-full my-1">
                  <p>Date:</p>
                  <p>
                    <DateDisplay
                      date={
                        new Date(
                          preval`module.exports = new Date().toLocaleString();`,
                        )
                      }
                    />
                  </p>
                </div>
              </div>
            </div>
          </ModalInput>
        </div>
      </div>
      <ProjectSettings open={settingToggle} setOpen={setSettingToggle} />
      <Elements />
      <Sections />
      <Layer />
      <AnimatePresence>
        {leftWidget === "pages" && <PagesSwitcher />}
        {leftWidget === "components" && <Components />}
        {leftWidget === "typography" && <Typography />}
      </AnimatePresence>
    </motion.div>
  );
};

export default GrigoraLeftBar;
